<script setup lang="ts">
import CheckboxField from '@shared/form/CheckboxField/CheckboxField.vue';

const akkoord = defineModel<boolean>();
const disabled = defineModel<boolean>('disabled');
const errors = defineModel<(string | undefined)[]>('errors');
</script>
<template>
  <div class="border-t border-grey-200 bg-grey-100 px-4 lg:px-8">
    <div class="@container">
      <div class="flex justify-center py-6 @2xl:py-8">
        <label
          class="flex cursor-pointer gap-4 rounded-lg border border-grey-300 bg-white px-6 py-4"
        >
          <CheckboxField :disabled path="akkoord" v-model="akkoord" />

          <span class="flex max-w-96 flex-col gap-1 self-center">
            <span class="font-bold">
              Hierbij bevestig ik dat ik de samenwerkingsovereenkomst heb doorgenomen en de inhoud
              ervan begrijp en akkoord ga met de voorwaarden.
            </span>
            <span v-if="errors" class="text-sm text-red">{{ errors.join(',') }}</span>
          </span>
        </label>
      </div>
    </div>
  </div>
</template>
